import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '../../../app.store';

export const shapeDrawStateSelector = (state: AppState) => state.frontendState.mapTools.shapeDraw;
export const useShapeDrawStateSelector = () => useSelector(shapeDrawStateSelector);

const isShapeDrawActiveSelector = (state: AppState) => state.frontendState.mapTools.shapeDraw.isActive;
export const useIsShapeDrawActiveSelector = () => useSelector(isShapeDrawActiveSelector);
